var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userPersona === 'backoffice')?_c('Backoffice',{attrs:{"notification":_vm.notification}}):_vm._e(),(_vm.userPersona === 'partner')?_c('Partner',{attrs:{"notification":_vm.notification},on:{"view-campaign-details":_vm.viewCampaignDetails}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }